<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Public Holidays</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button class="btn add-btn" @click="add">
            <i class="fa fa-plus"></i>Add Public Holiday
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Search Filter -->
    <div class="row filter-row">
      <div class="col-sm-6 col-md-3">
        <div class="form-group">
          <select class="form-control" v-model="countryId">
            <option value>All Countries</option>
            <option v-for="item in countries" :key="item.Id" :value="item.Id">
              {{ item.Name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div class="form-group">
          <select class="form-control" v-model="year">
            <option v-for="item in years" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <!-- /Search Filter -->

    <!-- Pagination -->
    <div class="row mt-3">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="no-col">S/N</th>
                <th class="country-col">
                  <button class="btn p-0" @click="setSortBy('country')">
                    Country
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'country'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'country_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="holiday-col">
                  <button class="btn p-0" @click="setSortBy('holiday')">
                    Public Holiday
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'holiday'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'holiday_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="date-col">
                  <button class="btn p-0" @click="setSortBy('date')">
                    Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'date'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'date_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="day-col">
                  <button class="btn p-0" @click="setSortBy('day')">
                    Day
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'day'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'day_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="remarks-col">
                  <button class="btn p-0" @click="setSortBy('remarks')">
                    Remarks
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'remarks'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'remarks_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="action-col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in publicHolidays" :key="item.Id">
                <td class="no-col">
                  {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    i +
                    1
                  }}
                </td>
                <td class="country-col">{{ item.CountryName }}</td>
                <td class="holiday-col">{{ item.Name }}</td>
                <td class="date-col">{{ item.DateDisplay }}</td>
                <td class="day-col">{{ item.Day }}</td>
                <td class="remarks-col">{{ item.Remarks }}</td>
                <td class="action-col">
                  <div class="dropdown dropdown-action">
                    <a
                      href="#"
                      class="action-icon dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="material-icons">more_vert</i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button class="dropdown-item" @click="edit(item)">
                        <i class="fa fa-pencil mr-2"></i>Edit
                      </button>
                      <button class="dropdown-item" @click="remove(item.Id)">
                        <i class="fa fa-trash-o mr-2"></i>
                        Delete
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="publicHolidays && !publicHolidays.length">
                <td colspan="7" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="publicHolidays && publicHolidays.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          publicHolidays.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->

    <!-- Add Holiday Modal -->
    <div class="modal custom-modal fade" id="addHoliday" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ form.Id ? "Edit" : "Add" }} Public Holiday
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="save">
              <div class="form-group">
                <label>Country<span class="text-danger">*</span></label>
                <select class="form-control" v-model="form.CountryId" required>
                  <option value>-- Select Country --</option>
                  <option
                    v-for="item in countries"
                    :key="item.Id"
                    :value="item.Id"
                  >
                    {{ item.Name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Holiday Name<span class="text-danger">*</span></label>
                <input
                  class="form-control"
                  type="text"
                  v-model="form.Name"
                  required
                />
              </div>
              <div class="form-group">
                <label>Holiday Date<span class="text-danger">*</span></label>
                <div>
                  <input
                    class="form-control"
                    type="date"
                    v-model="form.DateInput"
                    required
                  />
                </div>
              </div>
              <div class="form-group">
                <label>Remarks</label>
                <div>
                  <textarea
                    v-model="form.Remarks"
                    placeholder=""
                    class="form-control"
                  >
                  </textarea>
                </div>
              </div>
              <div class="submit-section">
                <button class="btn btn-primary submit-btn">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- /Add Holiday Modal -->
  </div>
</template>


<script>
import API from "../../http-common.js";
import config from "../../config.js";
import $ from "jquery";
export default {
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      countryId: "",
      countries: [],
      year: "",
      years: [],
      publicHolidays: [],
      //form
      form: {
        Id: "",
        CountryId: "",
        Name: "",
        DateInput: "",
        Remarks: "",
      },
      //for pagination
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.Token;
    },
  },
  watch: {
    countryId() {
      this.getPublicHolidays();
    },
    year() {
      this.getPublicHolidays();
    },
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.getPublicHolidays();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    getCountries() {
      API.common
        .getCountries({ Token: this.token })
        .then((response) => {
          if (response.data.success) {
            this.countries = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getPublicHolidays() {
      let param = {
        Token: this.token,
        CountryId: this.countryId,
        YearInput: this.year,
        CurrentPage: this.paging.CurrentPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
      };
      this.$store.state.isLoading = true;
      API.publicHoliday
        .getPublicHolidayList(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.publicHolidays = response.data.data;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
            this.years = response.data.years;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    add() {
      this.form.Id = "";
      this.form.CountryId = "";
      this.form.Name = "";
      this.form.DateInput = "";
      this.form.Remarks = "";
      $("#addHoliday").modal("show");
    },
    edit(payload) {
      this.form = {
        Id: payload.Id,
        CountryId: payload.CountryId,
        Name: payload.Name,
        DateInput: payload.DateCal,
        Remarks: payload.Remarks,
      };
      $("#addHoliday").modal("show");
    },
    save() {
      let param = {
        Token: this.token,
        Id: this.form.Id,
        CountryId: this.form.CountryId,
        Name: this.form.Name,
        DateInput: this.form.DateInput,
        Remarks: this.form.Remarks,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the public holiday?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willUpdate) => {
        if (willUpdate) {
          API.publicHoliday
            .savePublicHoliday(param)
            .then((response) => {
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.countryId = this.form.CountryId;
                this.year = new Date(this.form.DateInput).getFullYear();
                this.getPublicHolidays();
                $("#addHoliday").modal("hide");
              }
            })
            .catch((error) => {
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    remove(Id) {
      let param = {
        Token: this.token,
        Id: Id,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the public holiday?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          API.publicHoliday
            .deletePublicHoliday(param)
            .then((response) => {
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.getPublicHolidays();
              }
            })
            .catch((error) => {
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    //for pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getPublicHolidays();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getPublicHolidays();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getPublicHolidays();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getPublicHolidays();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getPublicHolidays();
    },
    setSortBy(payload) {
      switch (payload) {
        case "country":
          if (this.paging.SortBy === "country") {
            this.paging.SortBy = "country_desc";
          } else if (this.paging.SortBy === "country_desc") {
            this.paging.SortBy = "country";
          } else {
            this.paging.SortBy = "country";
          }
          break;
        case "holiday":
          if (this.paging.SortBy === "holiday") {
            this.paging.SortBy = "holiday_desc";
          } else if (this.paging.SortBy === "holiday_desc") {
            this.paging.SortBy = "holiday";
          } else {
            this.paging.SortBy = "holiday";
          }
          break;
        case "date":
          if (this.paging.SortBy === "date") {
            this.paging.SortBy = "date_desc";
          } else if (this.paging.SortBy === "date_desc") {
            this.paging.SortBy = "date";
          } else {
            this.paging.SortBy = "date";
          }
          break;
        case "day":
          if (this.paging.SortBy === "day") {
            this.paging.SortBy = "day_desc";
          } else if (this.paging.SortBy === "day_desc") {
            this.paging.SortBy = "day";
          } else {
            this.paging.SortBy = "day";
          }
          break;
        case "remarks":
          if (this.paging.SortBy === "remarks") {
            this.paging.SortBy = "remarks_desc";
          } else if (this.paging.SortBy === "remarks_desc") {
            this.paging.SortBy = "remarks";
          } else {
            this.paging.SortBy = "remarks";
          }
          break;
      }
      this.getPublicHolidays();
    },
  },
  created() {
    this.getCountries();
    this.year = new Date().getFullYear();
  },
};
</script>

<style scoped>
.country-col {
  width: 20%;
}
.holiday-col {
  width: 20%;
}
.day-col {
  width: 8%;
}
</style>



// WEBPACK FOOTER //
// src/components/MainAdmin/PublicHoliday.vue